<template>

<div class="register-page">

<div class="register-card">

<h2 class="title">
CONFIGURACIÓN DE CUENTA
</h2>

<!-- PROFILE -->
<div class="profile-section">

<label class="image-upload">

<img
v-if="preview"
:src="preview"
class="profile-img"
/>

<div v-else class="profile-placeholder">

Upload Photo

</div>

<input
type="file"
@change="handleImage"
hidden
/>

</label>

</div>

<form @submit.prevent="registerUser">

<div class="input-group">

<label>NOMBRE</label>

<input
type="text"
v-model="form.full_name"
required
/>

</div>

<div class="input-group">

<label>EMAIL</label>

<input
type="email"
v-model="form.email"
required
/>

</div>


<div class="input-group">

<label>TELEFONO</label>

<input
type="text"
v-model="form.phone"
@input="formatPhone"
maxlength="14"
placeholder="(310) 555-1234"
required
/>

</div>

<div class="input-group">

<label>CONTRASEÑA</label>

<div class="password-box">

<input
:type="showPassword?'text':'password'"
v-model="form.password"
required
/>

<span
class="eye"
@click="showPassword=!showPassword"
>
👁
</span>

</div>

</div>

<div class="input-group">

<label>CONFIRMAR</label>

<div class="password-box">

<input
:type="showConfirm?'text':'password'"
v-model="form.password_confirmation"
required
/>

<span
class="eye"
@click="showConfirm=!showConfirm"
>
👁
</span>

</div>

</div>

<button 
class="register-btn"
:disabled="isLoading"
>

<span v-if="!isLoading">
CREAR PERFIL
</span>

<span v-if="isLoading" class="loader2">
Creating Account...
</span>

</button>

</form>

</div>

<!-- SUCCESS MODAL -->

<div
v-if="showWelcome"
class="welcome-overlay"
>

<div class="welcome-card">

<div class="avatar-ring">

<img
v-if="preview"
:src="preview"
class="welcome-avatar"
/>

</div>

<div class="success-icon">

<svg viewBox="0 0 52 52">

<circle cx="26" cy="26" r="25"/>

<path d="M14 27 L22 35 L38 18"/>

</svg>

</div>

<h2 class="welcome-title">

Bienvenido a Luinny

</h2>

<h3 class="welcome-user">

{{form.full_name}}

</h3>

<p class="welcome-text">

Tu cuenta se ha creado correctamente.
Estamos preparando tu experiencia.

</p>

<div class="progress">

<div class="progress-fill"></div>

</div>

<p class="redirect-text">

Redireccionando a tu panel de control...

</p>

</div>

</div>

</div>

</template>

<script>

import {HTTP}
from '../../_helper/http-constants.js';

export default{

data(){

return{

preview:null,

showPassword:false,

showConfirm:false,

showWelcome:false,
isLoading:false,

form:{

full_name:"",
email:"",
password:"",
password_confirmation:"",
profile_image:null,
device_type:"web"

}

}

},

methods:{

handleImage(e){

const file=e.target.files[0];

this.form.profile_image=file;

this.preview=
URL.createObjectURL(file);

},

formatPhone(){

let numbers = this.form.phone.replace(/\D/g,'');

if(numbers.length > 10){
numbers = numbers.substring(0,10);
}

let formatted = numbers;

if(numbers.length > 6){
formatted = `(${numbers.substring(0,3)}) ${numbers.substring(3,6)}-${numbers.substring(6,10)}`;
}
else if(numbers.length > 3){
formatted = `(${numbers.substring(0,3)}) ${numbers.substring(3,6)}`;
}
else if(numbers.length > 0){
formatted = `(${numbers.substring(0,3)}`;
}

this.form.phone = formatted;

},

async registerUser(){

if(this.isLoading) return;

if(this.form.password != this.form.password_confirmation){
alert("Passwords do not match");
return;
}

this.isLoading = true;

try{

const formData = new FormData();

formData.append("full_name",this.form.full_name);
formData.append("email",this.form.email);

const cleanPhone = this.form.phone.replace(/\D/g,'');
formData.append("phone",cleanPhone);

formData.append("password",this.form.password);
formData.append("password_confirmation",this.form.password_confirmation);

formData.append("device_type","web");

if(this.form.profile_image){
formData.append("profile_image",this.form.profile_image);
}

await HTTP.post("/auth/register",formData);

const response = await HTTP.post("/auth/login",{
email:this.form.email,
password:this.form.password,
device_type:"web"
});

localStorage.setItem("token",response.data.token);

const user={
user_id: response.data.user.id,
name: response.data.user.name,
email: response.data.user.email,
profile_image: response.data.user.profile_image,
role: response.data.user.role,
device_type: response.data.user.device_type
};

localStorage.setItem("user",JSON.stringify(user));

this.showWelcome=true;

setTimeout(()=>{
window.location.href="/home";
},3000);

}
catch(error){

alert(
error.response?.data?.message ||
"Registration failed"
);

}
finally{
this.isLoading=false;
}

}

}

}

</script>

<style>

.register-page{

padding: 30px;

display:flex;

justify-content:center;

align-items:center;

background:

radial-gradient(circle at 25% 25%,#0f5c7a,transparent),
radial-gradient(circle at 80% 70%,#021a2d,transparent),
#000;

font-family:system-ui;

}

.register-card{

width:420px;

padding:45px;

border-radius:20px;

background:

rgba(0,0,0,.75);

backdrop-filter:blur(20px);

color:white;

box-shadow:

0 0 60px rgba(42,164,214,.15);

}

.title{

text-align:center;

margin-bottom:30px;

letter-spacing:2px;

font-weight:500;

color:#8edcff;

}

.profile-section{

display:flex;

justify-content:center;

margin-bottom:25px;

}

.profile-img{


border-radius:100%;

border:3px solid #2aa4d6;

object-fit:cover;

}

.profile-placeholder{

width:110px;

height:110px;

border-radius:100%;

background:#021524;

display:flex;

justify-content:center;

align-items:center;

color:#6ec6e8;

}

.input-group{

margin-bottom:18px;

}

.input-group label{

font-size:12px;

opacity:.6;

}

.input-group input{

width:100%;

padding:14px;

border-radius:10px;

border:none;

background:

rgba(255,255,255,.06);

color:white;

margin-top:5px;

}

.password-box{

position:relative;
width: 100%;

}

.eye{

position:absolute;

right:12px;

top:13px;

cursor:pointer;

opacity:.6;

}

.register-btn{

width:100%;

padding:15px;

border-radius:12px;

border:none;

background:

linear-gradient(90deg,#2aa4d6,#0f5c7a);

color:white;

font-size:16px;

cursor:pointer;

margin-top:10px;

transition:.3s;

}

.register-btn:hover{

transform:translateY(-2px);

box-shadow:

0 10px 25px rgba(42,164,214,.3);

}

/* MODAL */

.welcome-overlay{

position:fixed;

inset:0;

background:

radial-gradient(circle,#021524,#000);

display:flex;

justify-content:center;

align-items:center;

z-index:99999;

animation:fade .4s;

}

.welcome-card{

width:420px;

padding:55px 40px;

border-radius:24px;

text-align:center;

background:

linear-gradient(180deg,#021a2d,#01060b);

border:

1px solid rgba(42,164,214,.3);

box-shadow:

0 0 100px rgba(42,164,214,.2);

animation:popup .5s;

}

.avatar-ring{

width:110px;

height:110px;

margin:auto;

padding:4px;

border-radius:100%;

background:

linear-gradient(140deg,#2aa4d6,#0f5c7a);

animation:pulse 2s infinite;

}

.welcome-avatar{

width:100%;

height:100%;

border-radius:100%;

object-fit:cover;

}

.success-icon{

margin-top:15px;

}

.success-icon svg{

width:60px;

stroke:#2aa4d6;

stroke-width:3;

fill:none;

}

.success-icon circle{

stroke-dasharray:160;

stroke-dashoffset:160;

animation:circle .7s forwards;

}

.success-icon path{

stroke-dasharray:50;

stroke-dashoffset:50;

animation:path .5s .7s forwards;

}

.welcome-title{

margin-top:15px;

color:#8edcff;

}

.welcome-user{

margin-top:5px;

font-weight:500;

}

.welcome-text{

opacity:.7;

margin-top:15px;

line-height:1.5;

}

.progress{

height:6px;

border-radius:20px;

background:#021524;

margin-top:25px;

overflow:hidden;

}

.progress-fill{

height:100%;

width:0;

background:

linear-gradient(90deg,#2aa4d6,#66e0ff);

animation:load 3s forwards;

}

.redirect-text{

margin-top:15px;

font-size:13px;

opacity:.6;

}

/* ANIMATIONS */

@keyframes popup{

from{

transform:scale(.7);

opacity:0;

}

to{

transform:scale(1);

opacity:1;

}

}

@keyframes fade{

from{opacity:0}

to{opacity:1}

}

@keyframes pulse{

0%{

box-shadow:0 0 0 0 rgba(42,164,214,.5);

}

70%{

box-shadow:0 0 0 18px rgba(42,164,214,0);

}

100%{

box-shadow:0 0 0 0 rgba(42,164,214,0);

}

}

@keyframes circle{

to{stroke-dashoffset:0}

}

@keyframes path{

to{stroke-dashoffset:0}

}

@keyframes load{

to{width:100%}

}

.loader2{
display:flex;
align-items:center;
justify-content:center;
gap:8px;
}

.loader2:before{
content:'';
width:16px;
height:16px;
border:3px solid rgba(255,255,255,.3);
border-top:3px solid white;
border-radius:50%;
animation:spin .7s linear infinite;
}

.register-btn:disabled{
opacity:.6;
cursor:not-allowed;
}

@keyframes spin{
to{
transform:rotate(360deg);
}
}

</style>